import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs/Subscription'
import { AdministrationService } from '../../services/administration.service'
import { ActivatedRoute, Router } from '@angular/router'
import { FuseNavigationService } from '../../../core/components/navigation/navigation.service'
import { FuseConfigService } from '../../../core/services/config.service'
import { dutch } from './i18n/nl'
import { FuseTranslationLoaderService } from '../../../core/services/translation-loader.service'
import { AdministrationModel } from '../../models/administration.model'

@Component({
  selector: 'app-ledger',
  templateUrl: './ledger.component.html',
  styleUrls: ['./ledger.component.scss'],
})
export class LedgerComponent implements OnInit, OnDestroy {
  private administrationId: number
  currentAdministration: AdministrationModel
  layout = 'users'
  onAdminSelected: Subscription

  constructor(
    private administrationService: AdministrationService,
    private route: ActivatedRoute,
    private fuseConfig: FuseConfigService,
    private navigationService: FuseNavigationService,
    private router: Router,
    private translationLoader: FuseTranslationLoaderService,
  ) {
    this.administrationId = this.route.snapshot.params['administrationId']
    this.translationLoader.loadTranslations(dutch)

    if (this.route.snapshot.url.length === 3) {
      this.layout = this.route.snapshot.url[2].path
    }

    const navModel = this.navigationService.getNavigationModel()
    this.onAdminSelected = this.administrationService.onCurrentAdministationChanged.subscribe(administration => {
      if (this.currentAdministration === undefined) {
        navModel.pop()
      }

      this.currentAdministration = administration
      navModel.push({
        id: this.currentAdministration.id,
        title: this.currentAdministration.name,
        type: 'group',
        icon: 'apps',
        children: [
          {
            id: 'users',
            title: 'LEDGER.USERS',
            type: 'item',
            icon: 'supervisor_account',
            url: '/ledger/' + this.currentAdministration.id + '/users',
          },
          {
            id: 'documents',
            title: 'LEDGER.DOCS',
            type: 'item',
            icon: 'view_headline',
            url: '/ledger/' + this.currentAdministration.id + '/documents',
          },
        ],
      })
    })
  }

  ngOnInit() {
    if (!this.administrationId) {
      this.router.navigate(['dashboard'])
    }

    this.currentAdministration = JSON.parse(localStorage.getItem('currentAdmin'))

    if (this.currentAdministration.id != this.administrationId) {
      this.router.navigate(['dashboard'])
    }
  }

  ngOnDestroy() {
    // this.onAdminSelected.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/ledger/ledger.component.ts